exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#map[data-v-53bfe783] {\n    width: 100%;\n    height: 500px;\n}\n.warning[data-v-53bfe783] {\n    width: 100%;\n    margin-bottom: 20px;\n    background-color: rgba(255, 184, 24, 0.75);\n    border-radius: 5px;\n    color: #ffffff;\n    padding: 10px 20px 10px 20px;\n}\n.bold[data-v-53bfe783] {\n    font-weight: bold;\n}\n", ""]);

// exports
